import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TermComponent } from './term.component';
import { LanguageInterceptor } from '../shared/language-interceptor.service';

@NgModule({
  providers:[LanguageInterceptor],
  imports: [
    RouterModule.forChild([
      { path: ':language/terms-of-use', component:TermComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'TERMS_OF_USE_URL'}},
      { path: ':language/terminos-y-condiciones', component:TermComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'TERMS_OF_USE_URL'}},
      { path: ':language/conditions-utilisation', component:TermComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'TERMS_OF_USE_URL'}},
      { path: ':language/termini-di-utilizzo', component:TermComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'TERMS_OF_USE_URL'}},
      { path: ':language/nutzungsbedingungen', component:TermComponent, canActivate:[LanguageInterceptor], data:{localeTag: 'TERMS_OF_USE_URL'}}
    ])
  ]
})
export class TermRoutingModule {
}
